import React from 'react'
import Nav from '../components/Nav'
import support from '../images/customer.png'
import address from '../images/address.png'
import email from '../images/email.png'
import phone from '../images/phone.png'
import Circles from '../components/Circles'
import Footer from '../components/Footer'
import mac from '../images/mac.png'
import {Link} from 'react-router-dom'
const Support = () => {
  return (
    <div className="font-poppins">
        <Nav/>
        <div className="my-10 px-40 py-20">
            <div>
                <p className="font-bold text-2xl">We are always there to help you!</p>
                <p className="mt-5 text-2xl">Connect with us for any help you need</p>
                <div className="grid grid-cols-2 mt-10 items-center">
                    <div className="flex flex-col space-y-16">
                        {/* <div className=" flex items-start space-x-4">
                            <img src={address} className="-mt-4 h-16"></img>
                            <div>
                            <p className="text-2xl">Address</p>
                            <p>Novelio Technologies Private Limited 7th Floor, Vatika Triangle, Mehrauli-Gurgaon Road, Block B, Sushant Lok Phase-1, Gurugram, Delhi, India</p>
                            </div>
                        </div> */}
                        <div className="flex items-start space-x-4">
                            <img src={email} className="-mt-4 h-16"></img>
                            <div>
                            <p className="text-2xl">Email</p>
                            <a href="mailto:info@interviewguru.co">info@interviewguru.co</a>
                            </div>
                        </div>
                        <div className="flex items-start space-x-4">
                            <img src={phone} className="-mt-4 h-16"></img>
                            <div>
                            <p className="text-2xl">Contact</p>
                            <p>+91 76204 56853</p>
                            </div>
                        </div>
                    </div>
                    <div className="overflow-x-clip relative">
                        <Circles color="#148EFF1F" className="absolute left-1/2 top-1/2"></Circles>
                        <img src={support} className="h-80 mx-auto"></img>
                    </div>
                </div>
            </div>
        </div>
        <div className="my-10 py-20 px-40">
                <div className="bg-[#148EFFE5] rounded-xl px-10 py-10">
                    <div className="grid grid-cols-2 gap-5 items-center">
                        <img src={mac}></img>
                        <div className="text-white">
                            <p className="text-2xl font-bold">The 1st AI recruitment co-pilot you will ever hire!</p>
                            <p className="text-xl my-2">Hire faster, deliver efficiency!</p>
                            <Link to="/request">
                            <button className="bg-white px-5 py-2 rounded-xl mt-5 text-[#148EFFE5]">Schedule a call</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        <Footer/>
    </div>
  )
}

export default Support